import { render, staticRenderFns } from "./menu-build.vue?vue&type=template&id=e9a752d6&scoped=true"
import script from "./menu-build.vue?vue&type=script&lang=js"
export * from "./menu-build.vue?vue&type=script&lang=js"
import style0 from "./menu-build.vue?vue&type=style&index=0&id=e9a752d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a752d6",
  null
  
)

export default component.exports